var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobSinglePageBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 720,
    viewBox: "0 0 1920 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2203",
    "data-name": "Rectangle 2203",
    width: 1920,
    height: 720,
    transform: "translate(0 97)",
    fill: "#3b60bc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_36",
    "data-name": "Subtraction 36",
    d: "M968,1202c-24.154,0-48.586-.5-72.619-1.5-23.8-.983-47.864-2.475-71.531-4.436-23.44-1.941-47.1-4.394-70.328-7.292-23.048-2.874-46.268-6.261-69.015-10.067-22.564-3.773-45.3-8.067-67.587-12.761-22.092-4.654-44.313-9.826-66.047-15.372-21.589-5.511-43.253-11.534-64.393-17.9-21.021-6.334-42.092-13.181-62.626-20.352-20.445-7.14-40.883-14.784-60.746-22.72-19.8-7.907-39.563-16.32-58.754-25-19.114-8.649-38.173-17.8-56.65-27.208-18.441-9.389-36.754-19.257-54.43-29.331-17.649-10.056-35.177-20.611-52.1-31.37-16.894-10.743-33.6-21.957-49.653-33.33s-31.906-23.22-47.1-35.206S14.281,883.712,0,871.149V0H1920V884.941c-21.257,17.957-43.7,35.49-66.7,52.11-28.222,20.391-58.135,40.035-88.909,58.385-30.849,18.395-63.277,35.915-96.383,52.074-33.265,16.237-68,31.482-103.228,45.31-35.472,13.923-72.293,26.739-109.443,38.092-37.482,11.455-76.183,21.689-115.028,30.419-39.276,8.828-79.645,16.328-119.985,22.291-40.841,6.039-82.665,10.651-124.312,13.708C1053.771,1200.429,1010.7,1202,968,1202Z",
    transform: "translate(0 -0.468)",
    fill: "#2f59c5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2076",
    "data-name": "Group 2076",
    transform: "translate(0 -97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 1920,
    height: 720,
    transform: "translate(0 97)",
    fill: "#3b60bc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1855",
    "data-name": "Mask Group 1855",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2075",
    "data-name": "Group 2075",
    transform: "translate(0 97.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_33",
    "data-name": "Subtraction 33",
    d: "M968,1202c-24.154,0-48.586-.5-72.619-1.5-23.8-.983-47.864-2.475-71.531-4.436-23.44-1.941-47.1-4.394-70.328-7.292-23.048-2.874-46.268-6.261-69.015-10.067-22.564-3.773-45.3-8.067-67.587-12.761-22.092-4.654-44.313-9.826-66.047-15.372-21.589-5.511-43.253-11.534-64.393-17.9-21.021-6.334-42.092-13.181-62.626-20.352-20.445-7.14-40.883-14.784-60.746-22.72-19.8-7.907-39.563-16.32-58.754-25-19.114-8.649-38.173-17.8-56.65-27.208-18.441-9.389-36.754-19.257-54.43-29.331-17.649-10.056-35.177-20.611-52.1-31.37-16.894-10.743-33.6-21.957-49.653-33.33s-31.906-23.22-47.1-35.206S14.281,883.712,0,871.149V0H1920V884.941c-21.257,17.957-43.7,35.49-66.7,52.11-28.222,20.391-58.135,40.035-88.909,58.385-30.849,18.395-63.277,35.915-96.383,52.074-33.265,16.237-68,31.482-103.228,45.31-35.472,13.923-72.293,26.739-109.443,38.092-37.482,11.455-76.183,21.689-115.028,30.419-39.276,8.828-79.645,16.328-119.985,22.291-40.841,6.039-82.665,10.651-124.312,13.708C1053.771,1200.429,1010.7,1202,968,1202Z",
    transform: "translate(0 -0.468)",
    fill: "#3a60bc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1854",
    "data-name": "Mask Group 1854",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M147.084-8.592c81.235-4.743,143.243,57.265,138.5,138.5L186,1835.494c-4.743,81.235-74.442,150.933-155.676,155.677s-143.243-57.265-138.5-138.5L-8.592,147.084C-3.849,65.85,65.85-3.849,147.084-8.592Z",
    transform: "translate(-386.075 26.067) rotate(-45)",
    fill: "#ff8b01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M48.784-2.85c26.944-1.573,47.51,18.994,45.937,45.937L63.377,579.913c-1.573,26.944-24.691,50.061-51.634,51.634s-47.51-18.994-45.937-45.937L-2.85,48.784C-1.277,21.841,21.841-1.277,48.784-2.85Z",
    transform: "translate(-224.497 476.244) rotate(-45)",
    fill: "#f91f19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M48.784-2.85c26.944-1.573,47.51,18.994,45.937,45.937L63.377,579.913c-1.573,26.944-24.691,50.061-51.634,51.634s-47.51-18.994-45.937-45.937L-2.85,48.784C-1.277,21.841,21.841-1.277,48.784-2.85Z",
    transform: "translate(90.503 -200.879) rotate(-45)",
    fill: "#fee800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M80.113-4.68c44.246-2.583,78.021,31.191,75.437,75.437L113.6,789.186c-2.583,44.246-40.546,82.209-84.793,84.793s-78.021-31.191-75.437-75.437L-4.68,80.113C-2.1,35.867,35.867-2.1,80.113-4.68Z",
    transform: "translate(1258.412 665.194) rotate(-45)",
    fill: "#2d87ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M49.212-2.875c27.18-1.587,47.927,19.16,46.34,46.34L29.4,1176.489c-1.587,27.18-24.907,50.5-52.087,52.087s-47.927-19.16-46.34-46.34L-2.875,49.212C-1.288,22.032,22.032-1.288,49.212-2.875Z",
    transform: "translate(736.682 476.884) rotate(-45)",
    fill: "#008143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M70.024-4.091c38.674-2.258,68.2,27.263,65.937,65.937L82.6,975.685c-2.258,38.674-35.44,71.856-74.115,74.115s-68.2-27.263-65.937-65.937L-4.091,70.024C-1.832,31.35,31.35-1.832,70.024-4.091Z",
    transform: "translate(925.174 -157.491) rotate(-45)",
    fill: "#a03ce9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M49.846-2.912C77.377-4.519,98.391,16.5,96.784,44.025L70.276,498.014c-1.607,27.53-25.228,51.151-52.758,52.758s-48.545-19.407-46.937-46.937L-2.912,49.846C-1.3,22.316,22.316-1.3,49.846-2.912Z",
    transform: "translate(1622.14 156.083) rotate(-45)",
    fill: "#9d11a0"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 5,
    cy: 5.5,
    rx: 5,
    ry: 5.5,
    transform: "translate(312 490.532)",
    fill: "#fff",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 5,
    cy: 5.5,
    rx: 5,
    ry: 5.5,
    transform: "translate(625 590.532)",
    fill: "#fff",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 10,
    cy: 11,
    rx: 10,
    ry: 11,
    transform: "translate(1341 1063.532)",
    fill: "#fff",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 4,
    cy: 4.5,
    rx: 4,
    ry: 4.5,
    transform: "translate(1157 867.532)",
    fill: "#fff",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 4,
    cy: 4.5,
    rx: 4,
    ry: 4.5,
    transform: "translate(1654 946.532)",
    fill: "#fff",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 4,
    cy: 4.5,
    rx: 4,
    ry: 4.5,
    transform: "translate(1412 660.532)",
    fill: "#fff",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 4,
    cy: 4.5,
    rx: 4,
    ry: 4.5,
    transform: "translate(1732 740.532)",
    fill: "#fff",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 5,
    cy: 5.5,
    rx: 5,
    ry: 5.5,
    transform: "translate(177 365.532)",
    fill: "#fff",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 5,
    cy: 5.5,
    rx: 5,
    ry: 5.5,
    transform: "translate(647 401.532)",
    fill: "#fff",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 5,
    cy: 5.5,
    rx: 5,
    ry: 5.5,
    transform: "translate(1821 619.532)",
    fill: "#fff",
    opacity: 0.52
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2160",
    "data-name": "Rectangle 2160",
    width: 1920,
    height: 720,
    transform: "translate(0 97)",
    opacity: 0.19
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSinglePageBg);
export default __webpack_public_path__ + "static/media/job_single_page_bg.aa9e32d614a271bb8fd020c325ce5cb2.svg";
export { ForwardRef as ReactComponent };